import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * Card1 (Карты РФ) API
 * Оплата банковской картой (не P2P перевод)
 */

/**
 * Получить конфигурацию card1 (курсы и лимиты)
 */
export const fetchCardConfig = async () => {
  try {
    const response = await apiService.makeRequest('/api/card1/')

    if (response.card1) {
      return { ...response.card1, promo: response.promo || null }
    }

    throw new Error('Invalid response format: card1 config not found')
  } catch (error) {
    console.error('Error fetching Card config:', error)
    throw error
  }
}

/**
 * Получить пакеты для card1 из общего списка тарифов /api/topup/
 */
export const fetchCardPackages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.card1 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching Card packages:', error)
    throw error
  }
}

const normalizeCardCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'

  return response.error
}

/**
 * Создать платеж card1 по сумме в рублях
 */
export const createPaymentByRubles = async (rubles) => {
  try {
    const response = await apiService.makeRequest('/api/card1/', {
      method: 'POST',
      body: JSON.stringify({ rub: rubles })
    })

    const normalizedError = normalizeCardCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating Card payment by rubles:', error)
    throw error
  }
}

/**
 * Создать платеж card1 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/card1/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating Card payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату card1 через Telegram WebApp API
 */
export const openCardPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'Card', paymentWindow)
}

export default {
  fetchCardConfig,
  fetchCardPackages,
  createPaymentByRubles,
  createPaymentByCrystals,
  openCardPayment
}
